<p-toast></p-toast>
<app-loader [loading]="loading"></app-loader>

<div class="container-fluid">
  <div class="row">
    <div class="col-sm-8">
      <h6 class="text-dark pt-3 pb-2">AI Topic & SubTopic Management</h6>
    </div>
    <div class="col-sm-4 text-end">
      <!-- <button
        type="button"
        class="btn btn-sm btn-save-changes text-white m-2"
        (click)="saveAllChanges()"
        [disabled]="!hasChanges || saving">
        <i class="fa fa-save"></i> {{ saving ? 'Saving...' : 'Save All Changes' }}
      </button>
      <button
        type="button"
        class="btn btn-sm btn-reset-changes text-white m-2"
        (click)="resetChanges()"
        [disabled]="!hasChanges || saving">
        <i class="fa fa-refresh"></i> Reset Changes
      </button> -->
      <button
        type="button"
        class="btn btn-sm btn-add-site-user text-white m-2"
        (click)="openAddTopicModal()">
        <i class="fa fa-plus"></i> Add Topic
      </button>
      <button
        type="button"
        class="btn btn-sm btn-add-site-user text-white m-2"
        (click)="openAddSubTopicModal()">
        <i class="fa fa-plus"></i> Add SubTopic
      </button>
    </div>
  </div>

  <!-- <div class="row" *ngIf="hasChanges">
    <div class="col-sm-12">
      <div class="alert alert-warning">
        <i class="fa fa-exclamation-triangle"></i>
        You have unsaved changes. Remember to save your work!
      </div>
    </div>
  </div> -->

  <div class="row">
    <div class="col-sm-6">
      <div class="col-md-2" style="padding-bottom: 15px">
        <ng-select
          [placeholder]="'Select Topic'"
          [(ngModel)]="selectedTopic"
          (change)="onTopicChange($event)"
          dropdownPosition="bottom"
          [clearable]="false"
          style="width: 300px">
          <ng-option
            *ngFor="let topic of visibleTopics; trackBy: trackByTopicId"
            [value]="topic">
            {{ topic.topic_name }}
            <!-- <span class="action-badge-inline" [ngClass]="getActionBadgeClass(topic.action)">
              {{ topic.action }}
            </span> -->
          </ng-option>
        </ng-select>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="table-responsive" *ngIf="selectedSubTopics.length > 0">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>SubTopic Name</th>
            <th>Secondary Prompt</th>
            <th>Status</th>
            <th>Created Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let subTopic of visibleSubTopics; trackBy: trackBySubTopicId">
            <td>{{ subTopic.sub_topic_name }}</td>
            <td>{{ subTopic.secondary_prompt }}</td>
            <td>
              <!-- <span class="badge" [ngClass]="getActionBadgeClass(subTopic.action)">
                {{ subTopic.action }}
              </span> -->
              <span 
                class="badge"
                [class.bg-success]="subTopic.status"
                [class.bg-danger]="!subTopic.status">
                {{ subTopic.status ? 'Active' : 'Inactive' }}
              </span>
              <span *ngIf="subTopic.tempId" class="badge bg-info ms-1">
                Temp: {{ subTopic.tempId }}
              </span>
            </td>
            <td>{{ subTopic.created_date | date:'dd/MM/yyyy HH:mm' }}</td>
            <td>
              <button
                class="action-btn"
                (click)="editSubTopic(subTopic)"
                title="Edit SubTopic">
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="action-btn"
                (click)="deleteSubTopic(subTopic)"
                title="Delete SubTopic">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="no-records" *ngIf="selectedSubTopics.length === 0 && selectedTopic">
      <p>No SubTopics available for this topic</p>
    </div>
  </div>

  <div class="row" *ngIf="visibleTopics.length === 0 && !loading">
    <div class="col-sm-12">
      <div class="alert alert-info">
        <i class="fa fa-info-circle"></i>
        No topics available. Please add a topic to get started.
      </div>
    </div>
  </div>
</div>

<!-- Topic Modal -->
<div class="modal-overlay" *ngIf="showTopicModal" (click)="closeTopicModal()">
  <div class="modal-dialog modal-lg" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Manage Topics</h4>
        <button type="button" class="btn-close" (click)="closeTopicModal()">
          <i class="fa fa-times"></i>
        </button>
      </div>
      
      <div class="modal-body">
        <!-- Topics List -->
        <div *ngIf="!showAddTopicForm">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0">Existing Topics</h5>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="showAddTopicFormMethod()">
              <i class="fa fa-plus"></i> Add New Topic
            </button>
          </div>

          <div class="table-responsive" *ngIf="visibleTopics.length > 0">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Topic Name</th>
                  <th>Action Status</th>
                  <th>Created Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let topic of visibleTopics; trackBy: trackByTopicId">
                  <td>{{ topic.topic_name }}</td>
                  <td>
                    <span class="badge" [ngClass]="getActionBadgeClass(topic.action)">
                      {{ topic.action }}
                    </span>
                    <span *ngIf="topic.tempId" class="badge bg-info ms-1">
                      Temp: {{ topic.tempId }}
                    </span>
                  </td>
                  <td>{{ topic.created_date | date:'dd/MM/yyyy HH:mm' }}</td>
                  <td>
                    <button
                      class="action-btn"
                      (click)="editTopic(topic)"
                      title="Edit Topic">
                      <i class="fa fa-edit"></i>
                    </button>
                    <button
                      class="action-btn"
                      (click)="deleteTopic(topic)"
                      title="Delete Topic">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="no-records" *ngIf="visibleTopics.length === 0">
            <p>No topics available. Click "Add New Topic" to create one.</p>
          </div>
        </div>

        <!-- Add/Edit Form -->
        <div *ngIf="showAddTopicForm">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0">{{ editingTopic ? 'Edit Topic' : 'Add New Topic' }}</h5>
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              (click)="cancelEdit()">
              <i class="fa fa-arrow-left"></i> Back to List
            </button>
          </div>

          <form [formGroup]="topicForm" (ngSubmit)="saveTopicModal()">
            <div class="mb-3">
              <label for="topic_name">Topic Name *</label>
              <input
                type="text"
                id="topic_name"
                class="form-control"
                formControlName="topic_name"
                placeholder="Enter topic name"
                [class.is-invalid]="topicForm.get('topic_name')?.invalid && topicForm.get('topic_name')?.touched">
              <div class="invalid-feedback" *ngIf="getFieldError('topic_name', topicForm)">
                {{ getFieldError('topic_name', topicForm) }}
              </div>
            </div>

            <div class="mb-3" *ngIf="editingTopic">
              <div class="form-check">
                <input
                  type="checkbox"
                  id="status"
                  class="form-check-input"
                  formControlName="status">
                <label class="form-check-label" for="status">
                  Active
                </label>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeTopicModal()">
          Close
        </button>
        <button
          *ngIf="showAddTopicForm"
          type="button"
          class="btn btn-primary"
          (click)="saveTopicModal()"
          [disabled]="topicForm.invalid">
          {{ editingTopic ? 'Update Topic' : 'Add Topic' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- SubTopic Modal -->
<div class="modal-overlay" *ngIf="showSubTopicModal" (click)="closeSubTopicModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ modalMode === 'add' ? 'Add New SubTopic' : 'Edit SubTopic' }}</h4>
        <button type="button" class="btn-close" (click)="closeSubTopicModal()">
          <i class="fa fa-times"></i>
        </button>
      </div>
      
      <div class="modal-body">
        <form [formGroup]="subTopicForm" (ngSubmit)="saveSubTopicModal()">
          <div class="mb-3">
            <label for="topic_id">Select Topic *</label>
            <ng-select
              id="topic_id"
              [placeholder]="'Select a topic'"
              formControlName="topic_id"
              dropdownPosition="bottom"
              [disabled]="modalMode === 'edit'"
              [class.is-invalid]="subTopicForm.get('topic_id')?.invalid && subTopicForm.get('topic_id')?.touched">
              <ng-option
                *ngFor="let topic of visibleTopics; trackBy: trackByTopicId"
                [value]="topic.topic_id"
                [disabled]="modalMode === 'edit'">
                {{ topic.topic_name }}
                <span *ngIf="topic.action !== 'same'" class="action-badge-inline" [ngClass]="getActionBadgeClass(topic.action)">
                  {{ topic.action }}
                </span>
              </ng-option>
            </ng-select>
            <div class="invalid-feedback" *ngIf="getFieldError('topic_id', subTopicForm)">
              {{ getFieldError('topic_id', subTopicForm) }}
            </div>
            <div *ngIf="visibleTopics.length === 0" class="text-muted mt-2">
              No topics available. Please add topics first.
            </div>
          </div>

          <div class="mb-3">
            <label for="sub_topic_name">SubTopic Name *</label>
            <input
              type="text"
              id="sub_topic_name"
              class="form-control"
              formControlName="sub_topic_name"
              placeholder="Enter subtopic name"
              [class.is-invalid]="subTopicForm.get('sub_topic_name')?.invalid && subTopicForm.get('sub_topic_name')?.touched">
            <div class="invalid-feedback" *ngIf="getFieldError('sub_topic_name', subTopicForm)">
              {{ getFieldError('sub_topic_name', subTopicForm) }}
            </div>
          </div>

          <div class="mb-3">
            <label for="secondary_prompt">Secondary Prompt *</label>
            <textarea
              id="secondary_prompt"
              class="form-control"
              formControlName="secondary_prompt"
              placeholder="Enter secondary prompt"
              rows="4"
              [class.is-invalid]="subTopicForm.get('secondary_prompt')?.invalid && subTopicForm.get('secondary_prompt')?.touched">
            </textarea>
            <div class="invalid-feedback" *ngIf="getFieldError('secondary_prompt', subTopicForm)">
              {{ getFieldError('secondary_prompt', subTopicForm) }}
            </div>
          </div>

          <div class="mb-3" *ngIf="modalMode === 'edit'">
            <div class="form-check">
              <input
                type="checkbox"
                id="status"
                class="form-check-input"
                formControlName="status">
              <label class="form-check-label" for="status">
                Active
              </label>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeSubTopicModal()">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="saveSubTopicModal()"
          [disabled]="subTopicForm.invalid">
          {{ modalMode === 'add' ? 'Add SubTopic' : 'Update SubTopic' }}
        </button>
      </div>
    </div>
  </div>
</div>

